import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { isModKeyPressed } from '@/utils/platform'
import { togglePanel } from './panelVisibility'

/** A text-entry element outside the assistant panel (where ⌘J must not fire). */
function isOtherTextField(el) {
  if (!el || el.closest?.('[data-ai-panel]')) return false
  const tag = el.tagName
  return tag === 'INPUT' || tag === 'TEXTAREA' || el.isContentEditable === true
    || el.getAttribute?.('contenteditable') === 'true' || el.getAttribute?.('contenteditable') === ''
}

/**
 * The "Ask Graphit" shortcut (⌘J / Ctrl+J), a window-level keydown like
 * CommandPalette's ⌘K, for every layout that mounts the assistant panel. It
 * stays out of the way while the viewer is typing in a text field (input,
 * textarea, contenteditable) - a rich editor or a browser/OS binding may own
 * ⌘J there - with one exception: the assistant's own composer. The panel
 * focuses the composer on open, so exempting it too would mean ⌘J could open
 * the panel but never close it. Closing loses nothing (the unsent draft
 * lives in the aiChat slice) and focus goes back to where it was before the
 * panel opened.
 */
export function useAssistantShortcut() {
  const dispatch = useDispatch()
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isModKeyPressed(e) || e.key.toLowerCase() !== 'j') return
      if (isOtherTextField(document.activeElement)) return
      e.preventDefault()
      dispatch(togglePanel())
    }
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [dispatch])
}
